var TextTypes = require("lib/academic/TextTypes");
var CurrentUser = require("lib/account/CurrentUser");

export function getPath(state) {
 	var fullPath = "/data";
	if (state.subjectType) {
		if (_.size(state.userIDs) > 0 && state.subjectType == SUBJECT_STUDENT_DASHBOARD) {
			fullPath += "/" + _.first(_.sortBy(state.userIDs));
		} else if (_.size(state.userIDs) > 0 && !allStudents(state)) {
			fullPath += "/" + _.sortBy(state.userIDs).join("-");
		} else {
			fullPath += "/" + ALL_STUDENT_PATH
		}

		fullPath += "/" + stateValueToParam(state.subjectType);
	}

	var queryParts = [];

	if (allowDates(state.subjectType)) {
		var spans = CurrentUser.get().expectations_date_spans;

		if (state.startDate) {
			queryParts.push("start_date=" + state.startDate);
		} else if (requiresDates(state.subjectType)) {
			queryParts.push("start_date=" + spans[0].start);
		}
		if (state.endDate) {
			queryParts.push("end_date=" + state.endDate);
		} else if (requiresDates(state.subjectType)) {
			queryParts.push("end_date=" + spans[0].end);
		}
	}
	// restrict to only allow widget digest dates
	if (allowWidgetPeriodDates(state.subjectType)) {
		var spans = CurrentUser.get().expectations_date_spans;
		if (state.startDate && state.endDate) { 

			queryParts.push("start_date=" + state.startDate);
			queryParts.push("end_date=" + state.endDate);

		} else {
			queryParts = [...queryParts, "start_date=" + spans[0].start, "end_date=" + spans[0].end];
		}
	}
	if (allowsText(state.subjectType)) {
		if (allowsTextVariety(state.subjectType)) {
			if (state.textVariety && (state.textVariety != DEFAULT_TEXT_VARIETY)) {
				queryParts.push("text_variety=" + state.textVariety);
			}
		}

		if (state.textID) {
			queryParts.push("text_id=" + state.textID);
		}

	}
	if (state.status) {
		queryParts.push("status=" + state.status);
	}

	if (state.readBook) {
		queryParts.push("read_book=" + state.readBook);
	}

	if (state.draft) {
		queryParts.push("draft=" + state.draft);
	}

	if (state.dueDate) {
		queryParts.push("dueDate=" + state.dueDate);
	}

	if (state.quizID) {
		queryParts.push("quiz_id=" + state.quizID);
	}

	if (state.essayID) {
		queryParts.push("essay_id=" + state.essayID);
	}

	if (state.controlMode) {
		queryParts.push("controlMode=" + state.controlMode);
	}

	if (hasPages(state.subjectType)) {
		if (state.order && ((state.userIDs == undefined) || (state.userIDs.length != 1))) {
			queryParts.push("order=" + state.order);
		}
		if (state.page) {
			queryParts.push("page=" + state.page);
		}
		if (state.perPage) {
			queryParts.push("per_page=" + state.perPage);
		}
	}

	if (state.studentList) {
		queryParts.push("student_list=" + state.studentList);
	}

	if (queryParts.length) {
		fullPath += "?" + queryParts.join("&");
	}

	return fullPath;
}

export function getRouteState(params) {
	var state = {};
	
	// Translate subject_type
	if (params.subject_type) {
		state.subjectType = paramKeyToSubjectType(params.subject_type);
		var subjectType = paramKeyToSubjectType(params.subject_type);
	}

	// Translate userIDs, if set
	if (params.user_ids && (params.user_ids != "everyone")) {
		state.userIDs = _.map(params.user_ids.split("-"), (x) => parseInt(x));
	} else {
		state.userIDs = [];
	}

	// Translate completion_status
	if (params.draft && params.draft === 'false') {
		state.draft = false
	} else if (params.draft && params.draft === 'true') {
		state.draft = true
	}

	// Translate due_date
	if (params.dueDate) {
		state.dueDate = params.dueDate
	}

	// Translate student_list
	if (params.student_list) {
		state.studentList = params.student_list
	}

	// Translate quiz_id
	if (params.quiz_id) {
		state.quizID = parseInt(params.quiz_id)
	}

	if (params.essay_id){
		state.essayID = parseInt(params.essay_id)
	}

	// Translate edit
	if (params.controlMode) {
		state.controlMode = params.controlMode
	}

	// Translate status
	if (params.status) {
		state.status = params.status
	}

	// Translate status
	if (params.read_book) {
		state.readBook = params.read_book
	}

	if (allowDates(state.subjectType) || allowWidgetPeriodDates(state.subjectType)) {
		
		var spans = CurrentUser.get().expectations_date_spans;

		if (params.start_date) {
			state.startDate = params.start_date;
		} else if (requiresDates(state.subjectType)) {
			state.startDate = spans[0].start;
		}
		if (params.end_date) {
			state.endDate = params.end_date;
		} else if (requiresDates(state.subjectType)) {
			state.endDate = spans[0].end;
		}
	}

	if (subjectType && hasPages(subjectType)) {
		if (state.userIDs.length == 1) {
			state.order = ORDER_BY_DATE;
		} else {
			if (subjectType == SUBJECT_READING_LEVELS) {
				state.order = params.order || ORDER_BY_STUDENT;
			} else {
				state.order = params.order || ORDER_BY_DATE;
			}		
		}
		if (params.page) {
			state.page = parseInt(params.page);
		}
		if (params.per_page) {
			state.perPage = parseInt(params.per_page);
		}
	}

	if (allowsText(subjectType)) {
		if (subjectType && allowsTextVariety(subjectType)) {
			// Use text varieties or insert selected
			state.textVariety = params.text_variety || DEFAULT_TEXT_VARIETY;
		}
		if (params.text_id) {
			state.textID = params.text_id;
		}
	}

	return state;
}

function allStudents(state) {
	return state.studentList && state.studentList === ALL_STUDENT_PATH
}

function stateValueToParam(subjectType) {
	return subjectType.toLowerCase().replace(/ /g, "_");
}

function paramKeyToSubjectType(paramKey) {
	var parts = _.map(paramKey.split("_"), (word) => {
		return word.charAt(0).toUpperCase() + word.slice(1);
	});
	return parts.join(" ");
}
export function allowDates(subjectType) {
	return !_.includes([
		SUBJECT_READING_LEVEL_GRAPH,
		SUBJECT_READING_LEVELS,
		SUBJECT_STUDENT_DASHBOARD,
		SUBJECT_GOALS,
	], subjectType)
}

export function allowWidgetPeriodDates(subjectType) {
	return _.includes([SUBJECT_GOALS], subjectType)
}

export function allowDraft(subjectType) {
	return _.includes([
		SUBJECT_TEACHER_PICKS
	], subjectType)
}
export function allowDueDate(subjectType) {
	return _.includes([
		SUBJECT_TEACHER_PICKS, SUBJECT_ACTIVITIES, SUBJECT_ASSIGNED_EXERCISES, SUBJECT_COMPLETED_EXERCISES
	], subjectType)
}
export  function allowAllDates(subjectType) {
	return !_.includes([SUBJECT_GOALS, SUBJECT_OTHER_METRICS], subjectType)
}
export function allowsText(subjectType) {
	return !_.includes([
		SUBJECT_READING_LEVEL_GRAPH,
		SUBJECT_READING_LEVELS,
		SUBJECT_GOALS, SUBJECT_OTHER_METRICS,
		SUBJECT_STUDENT_DASHBOARD
	], subjectType)
}
export function allowsTextVariety(subjectType) {
	return allowsText(subjectType) && !_.includes(
		[SUBJECT_LOG_LIST, SUBJECT_LOG_CALENDAR, SUBJECT_GOALS, SUBJECT_OTHER_METRICS, SUBJECT_TEACHER_PICKS,
			SUBJECT_ACTIVITIES, SUBJECT_ASSIGNED_EXERCISES, SUBJECT_COMPLETED_EXERCISES],
	subjectType)
}
export function allowsDrafts(subjectType) {
	return _.includes(
		[SUBJECT_QUIZZES, SUBJECT_ANSWERS, SUBJECT_REVIEWS, SUBJECT_ACTIVITIES],
	subjectType)
}
export function allowsStatus(subjectType) {
	return _.includes([SUBJECT_QUIZZES], subjectType)
}
export function allowsReadBookStatus(subjectType) {
	return _.includes([SUBJECT_BOOKS], subjectType)
}
export function allowsStudentFilter(subjectType) {
	return _.includes([SUBJECT_STUDENT_DASHBOARD], subjectType)
}
export function hasTotals(subjectType) {
	return hasPages(subjectType);
}
export function requiresLogReading(subjectType) {
	return _.includes([
		SUBJECT_LOG_LIST, SUBJECT_LOG_CALENDAR
	], subjectType)
}
export function requiresReadingLevelGraph(subjectType) {
	return _.includes([
		SUBJECT_READING_LEVEL_GRAPH
	], subjectType)
}
export function requiresDigitalExercises(subjectType) {
	return _.includes([
		SUBJECT_ACTIVITIES, SUBJECT_ASSIGNED_EXERCISES, SUBJECT_COMPLETED_EXERCISES, SUBJECT_TEACHER_PICKS
	], subjectType)
}
export function allowsPrinting(subjectType) {
	return !_.includes([
		SUBJECT_STUDENT_DASHBOARD, SUBJECT_READING_LEVEL_GRAPH, SUBJECT_ASSIGNED_EXERCISES, SUBJECT_COMPLETED_EXERCISES, SUBJECT_QUESTION_BUILDERS
	], subjectType)
}

export function allowsDownload(subjectType) {
	return _.includes([
		SUBJECT_GOALS, SUBJECT_OTHER_METRICS, SUBJECT_READING_LEVELS, SUBJECT_ACTIVITIES, SUBJECT_TEACHER_PICKS
	], subjectType)
}


export function requiresDates(subjectType) {
	return !_.includes([
		SUBJECT_GOALS, SUBJECT_OTHER_METRICS
	], subjectType)
}

export function timeKey(subjectType) {
	if (_.includes([SUBJECT_LOG_LIST, SUBJECT_LOG_CALENDAR], subjectType)) {
		return "log_date";

	} else if (_.includes([SUBJECT_BOOKS], subjectType)) {
		return "last_active_by_user_id";

	} else if (_.includes([SUBJECT_QUIZZES, SUBJECT_ANSWERS,
		SUBJECT_WRITING, SUBJECT_REVIEWS,
		SUBJECT_ACTIVITIES], subjectType)) {
		return "completed_at";

	} else {
		// ASIGNED_EXERCISES
		return "created_at";
	}
}

export function hasPages(subjectType) {
	if (_.includes([SUBJECT_QUIZZES, SUBJECT_ANSWERS, SUBJECT_REVIEWS, SUBJECT_WRITING, SUBJECT_ACTIVITIES, SUBJECT_READING_LEVELS], subjectType)) {
		return true;
	} else {
		return false;
	}
}

export function orderAsParam(orderType) {
	if (orderType == ORDER_BY_DATE) {
		return "completed_at_desc";
	} else {
		return "user_id_asc";
	}
}

export function subjectNoun(subjectType, singular) {
	if (singular) {
		return SUBJECT_NOUNS[subjectType][0];
	} else {
		return SUBJECT_NOUNS[subjectType][1];		
	}
}

export function getSubjectSubtypes(subjectType) {
	return SUBJECT_GROUPS.find(x => _.includes(x, subjectType));
}

export function getSubjectHeaderType(subjectType) {
	if (subjectType) {
		return getSubjectSubtypes(subjectType)[0];
	}
}

export function validWidgetStartDate(startDate) {
	var spans = CurrentUser.get().expectations_date_spans;
	return _.includes(_.pluck(spans, 'start'), startDate)
}

export function validWidgetEndDate(endDate) {
	var spans = CurrentUser.get().expectations_date_spans;
	return _.includes(_.pluck(spans, 'end'), endDate)
}

export var PER_PAGE = 20;
export var ALL_PER_PAGE = 10000; // Eek. Well, it's July.

export var DEFAULT_TEXT_VARIETY = TextTypes.Varieties.FICTION_AND_NON_FICTION;

export var ALL_STUDENT_PATH = 'everyone'

export var PATH = "/data/:user_ids?/:subject_type?";

export var STUDENT_DASHBOARD_PATH = "/data/student_dashboard";

////////////////
// Subjects ////
////////////////

export var SUBJECT_GOALS = "Goals";
export var SUBJECT_OTHER_METRICS = "Other Stats";

export var SUBJECT_BOOKS = "Books";
export var SUBJECT_LOG_LIST = "Reading Logs";
export var SUBJECT_LOG_CALENDAR = "Log Calendar";

export var SUBJECT_QUIZZES = "Quizzes";

export var SUBJECT_WRITING = "Writing";
export var SUBJECT_ANSWERS = "Practice Questions";
export var SUBJECT_REVIEWS = "Reviews";
export var SUBJECT_ESSAYS = "Essays"

export var SUBJECT_ACTIVITIES = "Activities";
export var SUBJECT_ASSIGNED_EXERCISES = "Assigned Exercises";
export var SUBJECT_COMPLETED_EXERCISES = "Completed Exercises";
export var SUBJECT_QUESTION_BUILDERS = "Question Builders";
export var SUBJECT_TEACHER_PICKS = "Teacher Picks";

export var SUBJECT_ANSWERS_SHORT = "Questions";

export var SUBJECT_READING_LEVELS = "Reading Levels";
export var SUBJECT_READING_LEVEL_GRAPH = "Reading Level Graph";

export var SUBJECT_STUDENT_DASHBOARD = "Students";

export var SUBJECT_GROUPS = [
	[
		SUBJECT_GOALS,
		SUBJECT_OTHER_METRICS
	], 
	[
		SUBJECT_BOOKS,
		SUBJECT_LOG_LIST,
		SUBJECT_LOG_CALENDAR
	], 
	[
		SUBJECT_QUIZZES
	], 
	[
		SUBJECT_WRITING,
		SUBJECT_ANSWERS,
		SUBJECT_REVIEWS,
		SUBJECT_ESSAYS
	], 
	[
		SUBJECT_ACTIVITIES,
		SUBJECT_ASSIGNED_EXERCISES,
		SUBJECT_COMPLETED_EXERCISES,
		SUBJECT_QUESTION_BUILDERS,
		SUBJECT_TEACHER_PICKS
	],
	[
		SUBJECT_READING_LEVELS,
		SUBJECT_READING_LEVEL_GRAPH
	],
	[
		SUBJECT_STUDENT_DASHBOARD
	],
]

////////////////////
// End Subjects ////
////////////////////

export var ORDER_BY_STUDENT = "user_id_asc";
export var ORDER_BY_DATE = "completed_at_desc";

export var ORDER_LABELS = {
	"By Date": ORDER_BY_DATE,
	"By Student": ORDER_BY_STUDENT
}

export var FLAGGED_STATUS = 'flagged'
export var FAILED_STATUS = 'failed'
export var PASSED_STATUS = 'passed'
export var ALL_STATUS = 'all'

export var STATUS_OPTIONS = [ALL_STATUS, FLAGGED_STATUS, FAILED_STATUS, PASSED_STATUS];

var SUBJECT_NOUNS = {
	[SUBJECT_BOOKS]: 				["book", "books"],
	[SUBJECT_LOG_LIST]: 			["log", "logs"],
	[SUBJECT_LOG_CALENDAR]: 		["log", "logs"],
	[SUBJECT_READING_LEVEL_GRAPH]: 	["book or assessment", "books or assessments"],
	[SUBJECT_QUIZZES]: 				["quiz", "quizzes"],
	[SUBJECT_ANSWERS]: 				["answer", "answers"],
	[SUBJECT_REVIEWS]: 				["review", "reviews"],
	[SUBJECT_ESSAYS]: 				['essay', 'essays'],
	[SUBJECT_WRITING]: 				["answer", "answers"],
	[SUBJECT_ACTIVITIES]: 			["activity", "activities"],
	[SUBJECT_ASSIGNED_EXERCISES]: ["assigned exercise", "assigned exercises"],
	[SUBJECT_COMPLETED_EXERCISES]: ["completed exercise", "completed exercises"],
	[SUBJECT_QUESTION_BUILDERS]: ["question builder", "question builders"],
	[SUBJECT_TEACHER_PICKS]: ["teacher pick", "teacher picks"],
}




// WEBPACK FOOTER //
// ./modules/lib/routing/DataRouting.js